module.exports = __webpack_public_path__ + "img/Price.a00aa044.svg";